import { API_CACHE_KEY } from '../services/api/accountsApi/keys';
import { RESET_ACCOUNTS_UNDER_NETWORK } from './actionTypes';

const resetAccountsUnderNetwork = () => ({
    type: RESET_ACCOUNTS_UNDER_NETWORK,
    metadata: { abortRequestsCacheKey: API_CACHE_KEY },
});

export default resetAccountsUnderNetwork;
